import { AppCard, AppCardBody, AppText, kindredFontFamilies } from "../../ui-foundation";
import {
  DocumentList,
  DocumentPageScaffold,
  DocumentSection,
} from "@/components/DocumentScaffold";
import {
  KINDRED_PHASE_ONE_ROLLOUT_COPY,
  KINDRED_FEEDBACK_CHANNEL_PATH,
  KINDRED_SUPPORT_EMAIL,
  STEADY_HOUSE_COMPANY_NUMBER,
  STEADY_HOUSE_FOUNDER_NAME,
  STEADY_HOUSE_LEGAL_NAME,
  STEADY_HOUSE_REGISTERED_OFFICE,
  STEADY_HOUSE_SUPPORT_URL,
} from "../../shared/support";
import KindredSocialLinksCard from "@/components/KindredSocialLinksCard";

const AboutKindred = () => {
  return (
    <DocumentPageScaffold
      title="About Kindred"
      updatedLabel="Last updated: April 2026"
      fallbackPath="/"
    >
      <DocumentSection title="1. What Kindred is">
        <AppText>
          Kindred is a support and community app for single parents. It combines community channels, direct
          messaging, local activities, events, and practical support packs designed around the realities of
          single-parent family life.
        </AppText>
        <AppText>{KINDRED_PHASE_ONE_ROLLOUT_COPY}</AppText>
      </DocumentSection>

      <DocumentSection title="2. Who runs Kindred">
        <AppText>
          Kindred Community is operated by {STEADY_HOUSE_LEGAL_NAME}, a company registered in England and
          Wales under company number {STEADY_HOUSE_COMPANY_NUMBER}.
        </AppText>
        <AppText>Registered office: {STEADY_HOUSE_REGISTERED_OFFICE}.</AppText>
        <AppText>
          Kindred is still intentionally founder-led. {STEADY_HOUSE_FOUNDER_NAME} created it from lived
          experience as a single parent who wanted support to feel warmer, safer, and more useful than the
          usual afterthought.
        </AppText>
      </DocumentSection>

      <DocumentSection title="3. What members can expect">
        <DocumentList
          items={[
            "A members-only space built for single-parent connection, mutual support, and practical help",
            "Clear rules on safety, behaviour, privacy, and child safeguarding",
            "In-app reporting, moderation, and admin review where content or behaviour creates risk",
            "Support packs that help members get oriented, without pretending to replace professional advice or one country's rules with another's",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="4. What Kindred is not">
        <DocumentList
          items={[
            "Not a dating app",
            "Not a crisis or emergency service",
            "Not legal, medical, therapeutic, or regulated financial advice",
            "Not a platform for child accounts or unsafe sharing of children’s information",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="5. Feedback, support, and complaints">
        <AppText>
          Kindred is meant to keep improving around what members actually need, not around a fixed launch
          script.
        </AppText>
        <AppText>
          Signed-in members can share bugs, feature ideas, and product suggestions in{" "}
          <strong>{KINDRED_FEEDBACK_CHANNEL_PATH}</strong>.
        </AppText>
        <AppText>
          For account help, safeguarding issues, privacy requests, or formal complaints, use the{" "}
          <a
            href={STEADY_HOUSE_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="kindred-inline-link"
          >
            Steady House support page
          </a>{" "}
          or email{" "}
          <a href={`mailto:${KINDRED_SUPPORT_EMAIL}`} className="kindred-inline-link">
            {KINDRED_SUPPORT_EMAIL}
          </a>
          .
        </AppText>
      </DocumentSection>

      <AppCard backgroundColor="$panelBackground">
        <AppCardBody alignItems="center">
          <AppText
            textAlign="center"
            fontFamily={kindredFontFamilies.sansBold}
            fontSize="$md"
            lineHeight="$md"
          >
            Kindred is a founder-led Steady House product: warm in tone, company-backed in responsibility,
            and shaped by member feedback.
          </AppText>
        </AppCardBody>
      </AppCard>

      <KindredSocialLinksCard
        sourceScreen="about-kindred"
        includeWebsite
        helperText="Kindred's website and social pages are here when you want updates outside the app."
      />
    </DocumentPageScaffold>
  );
};

export default AboutKindred;
